import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Form } from 'react-bootstrap';
import Toggle from "react-toggle";

export const FileMatchingModal = ({ show, onClose, fileData = [], onSave, quoteId }) => {
    const [toggleStates, setToggleStates] = useState([]);


    useEffect(() => {
        if (Array.isArray(fileData)) {
            setToggleStates(fileData);
        }
    }, [fileData])

    console.log('Toogle state ::', toggleStates);

    const handleToggleChange = (index) => {
        setToggleStates((pre) => {
            return pre.map((item, i) => {
                if (index == i) {
                    return { ...item, accept: !item.accept };
                }
                return item;
            })
        });
    };

    const handleSave = () => {
        // Process the toggle states
        let modifiedData = toggleStates.reduce((acc, item) => {
            const result = [...acc];
            console.log('item ::', item);
            if (item.threeDFile && item.twoDFile && !item.accept && !item.matchWithExistingLineItem) {
                console.log('Condition run');
                result.push({
                    threeDFile: item.threeDFile,
                    threeDFileName: item.threeDFile.name,
                    twoDFile: null,
                    accept: false,
                });
                result.push({
                    twoDFile: item.twoDFile,
                    twoDFileName: item.twoDFile.name,
                    threeDFile: null,
                    accept: false,
                });
            }
            else if (item.threeDFile && item.twoDFile && !item.accept && item.matchWithExistingLineItem) {
                const isThreeDFileAdded = item.isThreeDFileAdded;
                const isTwoFileAdded = item.isTwoFileAdded;
                if (isThreeDFileAdded) {
                    result.push({
                        threeDFile: item.threeDFile,
                        threeDFileName: item.threeDFile.name,
                        twoDFile: null,
                        accept: false,
                        matchWithExistingLineItem: item.matchWithExistingLineItem,

                    })
                }
                if (isTwoFileAdded) {
                    result.push({
                        twoDFile: item.twoDFile,
                        twoDFileName: item.twoDFile.name,
                        threeDFile: null,
                        accept: false,
                        matchWithExistingLineItem: item.matchWithExistingLineItem,

                    });
                }
            }
            else {
                result.push(item);
            }
            console.log('acc ::', result);
            return result;

        }, []);
        console.log('Modified file ::', modifiedData);
        onSave(modifiedData);
        onClose();
    };

    const isAnyFileFromQuote = toggleStates.some((item) => item?.matchWithExistingLineItem);

    return (
        <Modal show={show} onClose={onClose} size="lg" centered>
            <Modal.Header >
                <Modal.Title>Our system has detected two similar file names for the components below — one appears to be a 3D model and the other a technical drawing. Please confirm the correct entries. </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            {isAnyFileFromQuote ? <th>
                                Part index
                            </th> : null}
                            <th>
                                File name
                            </th>
                            <th>
                                Corresponding Technical drawing detected
                            </th>
                            <th>Accept?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {toggleStates.map((file, index) => {
                            const threeDFileNameWithoutExt = file.threeDFileName?.split('.')[0];
                            const twoDFileNameWithoutExt = file.twoDFileName?.split('.')[0];
                            if (threeDFileNameWithoutExt != twoDFileNameWithoutExt) return null;
                            return (
                                <tr key={index}>
                                    {isAnyFileFromQuote ? (
                                        <td>
                                            {file.lineItemIndex !== undefined && file.lineItemIndex !== null
                                                ? file.lineItemIndex + 1
                                                : 'New'}
                                        </td>
                                    ) : null}

                                    {/* 3D File */}
                                    <td className="relative overflow-hidden">
                                        {file.threeDFileName}
                                        {file.matchWithExistingLineItem && file.isThreeDFileAdded && (
                                            <span
                                                className="
          absolute top-0 left-0 bg-red-600 text-white text-center text-[8px] font-bold
          px-2 py-[1px] rotate-[-45deg] origin-top-left shadow-md
          translate-x-[-18px] translate-y-[30px]
          pointer-events-none select-none
        "
                                                style={{ width: "70px", overflow: "hidden", whiteSpace: "nowrap" }}
                                            >
                                                NEW
                                            </span>
                                        )}
                                    </td>

                                    {/* 2D File */}
                                    <td className="relative overflow-hidden">
                                        {file.twoDFileName}
                                        {file.matchWithExistingLineItem && file.isTwoFileAdded && (
                                            <span
                                                className="
          absolute top-0 left-0 bg-red-600 text-white text-center text-[8px] font-bold
          px-2 py-[1px] rotate-[-45deg] origin-top-left shadow-md
          translate-x-[-18px] translate-y-[30px]
          pointer-events-none select-none
        "
                                                style={{ width: "70px", overflow: "hidden", whiteSpace: "nowrap" }}
                                            >
                                                NEW
                                            </span>
                                        )}
                                    </td>

                                    <td>
                                        <Toggle
                                            defaultChecked={file.accept}
                                            checked={file.accept}
                                            icons={false}
                                            onChange={() => handleToggleChange(index)}
                                        />
                                    </td>
                                </tr>
                            )
                        }
                        ).filter(Boolean)}
                    </tbody>
                </Table>
                <p className="text-red-600 text-sm font-medium mt-2">
                    Note: If you choose not to accept, the newly file will still be uploaded, but it will appear as a
                    separate line item instead of being linked to an existing one.
                </p>
            </Modal.Body>

            <Modal.Footer>
                {/* <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button> */}
                <Button className='!bg-primaryColor' onClick={handleSave}>
                    Continue
                </Button>
            </Modal.Footer> 
        </Modal>
    );
};

